import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { map } from 'rxjs/operators';
import { openTeamForm } from '../../screens/team-form-modal/team-action-mock-team-form-modal.component';
import { TeamActionMockSettingsService } from '../../team-action-mock-settings.service';
import { TeamActionMockTeamsStore } from '../../team-action-mock-teams.store';
import { MOCK_SUPPORT } from '../../team-action-mock.data';

// Maquette d'estimation « action d'équipe » : onglet ÉQUIPES d'une fiche établissement Fonction support (données fictives).
@Component({
  selector: 'team-action-mock-establishment-teams-tab',
  templateUrl: './team-action-mock-establishment-teams-tab.component.html',
})
export class TeamActionMockEstablishmentTeamsTabComponent {
  readonly teams$ = this.store.teams$.pipe(map(teams => teams.filter(team => team.support === MOCK_SUPPORT)));

  constructor(
    public settings: TeamActionMockSettingsService,
    private store: TeamActionMockTeamsStore,
    private dialog: MatDialog,
  ) {}

  create(): void {
    openTeamForm(this.dialog, this.store, { support: MOCK_SUPPORT }).subscribe();
  }
}
